import styled from "styled-components";

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 0 16px 0 0;
  gap: 12px;
`;

export const FloatWrap = styled.div`
  position: absolute;
  height: calc(100vh - 68px);
  z-index: 10;
`;

export const GenAI = styled(FloatWrap)<{ isVisible?: boolean }>`
  width: 368px;
  margin: 0 12px;
  right: 0;
  display: flex;
  transform: translateX(${({ isVisible }) => (isVisible ? "0" : "100%")});
  transition: all 0.2s;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: var(--hv-surface-widget);
  border-radius: 12px;
  transition: margin-right 0.2s ease;
  padding-bottom: 20px;

  .mantine-ScrollArea-viewport > div {
    display: block !important;
  }
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
`;

export const ChartList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid var(--hv-border-default);
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
`;

export const ContextMenu = styled.div`
  position: absolute;
  top: 36px;
  right: 0px;
  display: flex;
  flex-direction: column;
  z-index: 2;
  width: 120px;
  height: 72px;
  background: var(--hv-surface-popup);
  border-radius: 4px;
  padding: 4px;
  border: 1px solid var(--hv-border-default);
  font-size: 14px;
  box-shadow: 0px 2px 4px 0px var(--hv-shadow-2);
  margin: 0;
  button {
    color: var(--hv-text-normal-primary);
    height: 28px;
    &:hover {
      background-color: var(--hv-interaction-hover);
    }
    &:active {
      background-color: var(--hv-interaction-press);
    }
  }
`;

export const FilterName = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: var(---hv-text-normal-primary);
`;

export const DropDownAndListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 20px 20px 20px;
`;

export const ChartFilterWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LocationName = styled.div``;

export const NoticeWrap = styled.div`
  width: 100%;
  height: calc(100vh - 198px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 12px;

  svg path,
  circle {
    stroke: var(--icon-emphasis);
  }
`;

export const NoticeTitile = styled.h1`
  font-size: var(--hv-fontsize-body-md);
  font-weight: var(--hv-font-weight-bold);
  color: var(--hv-text-normal-primary);
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const NoticeMessage = styled.p`
  font-size: 14px;
  font-weight: var(--hv-font-weight-regular);
  color: var(--hv-text-normal-tertiary);
  white-space: pre-line;
  text-align: center;
`;
